import { render, staticRenderFns } from "./linkedreview.vue?vue&type=template&id=6b740639"
import script from "./linkedreview.vue?vue&type=script&lang=ts"
export * from "./linkedreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports